import { render } from "./FfjbNavbar.vue?vue&type=template&id=0ab7bb77"
import script from "./FfjbNavbar.vue?vue&type=script&lang=js"
export * from "./FfjbNavbar.vue?vue&type=script&lang=js"

import "./FfjbNavbar.vue?vue&type=style&index=0&id=0ab7bb77&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__